// extracted by mini-css-extract-plugin
export var heading = "ArticleItem-module--heading--Izgp5";
export var imageWrapper = "ArticleItem-module--imageWrapper--Ik5Oe";
export var tags = "ArticleItem-module--tags--gAfH9";
export var wrapper = "ArticleItem-module--wrapper--KHJwc";